import * as WizardActions from './wizard-actions';
import * as WizardReducer from './wizard-reducer';

export {
    WizardActions,
    WizardReducer
};
